<template>
  <a-card :bordered="false">
    <!-- <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div> -->
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="baoming(record)" v-if="diffTime(record.signendTime)">报名</a>
          <a @click="onShowBaoming(record)">报名信息</a>
          <!-- <a @click="onEdit(record)">报名</a> -->
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <AddList ref="listModal" :form-primary-key-field="listKeyField" @onCloseModel="onCloseModel" />
  <a-modal width="600px" title="对接会报名" v-model:visible="visible" :maskClosable="false" :closable="false" @ok="onSubmit"
    @cancel="handleCancel">
    <a-form :labelCol="{ span: 6 }" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
      <a-row :gutter="[24, 8]">
        <a-col :span="24">
          <div class="hidden">
            <a-form-item label="id" name="id">
              <a-input v-model:value="form.id" />
            </a-form-item>
            <a-form-item label="活动id" name="activityId">
              <a-input v-model:value="form.activityId" placeholder="请输入活动id" />
            </a-form-item>
          </div>
          <a-form-item :labelCol='{ span: 6 }' label="报名人姓名" name="name">
            <a-input v-model:value="form.name" placeholder="请输入报名人姓名" />
          </a-form-item>
          <a-form-item :labelCol='{ span: 6 }' label="报名人电话" name="phone">
            <a-input v-model:value="form.phone" placeholder="请输入报名人电话" />
          </a-form-item>
          <a-form-item :labelCol='{ span: 6 }' label="预计报名人数" name="applyNum">
            <a-inputNumber style="width: 100%;" v-model:value="form.applyNum" placeholder="请输入" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import UserModal from './components/UserModal';
import AddList from './components/AddList';
import { tableListMixin, formMixin } from "@/mixins";
import { homeEducationInfo, activity } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";
import { defaultDateCustomRender } from "@/utils/customRender";
// import { message } from "ant-design-vue";
import dataCheck from "@/utils/dataCheck";
import { activityApi } from "@/api/innovationService";


const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "招聘会名称", dataIndex: "title", key: "title" },
  { title: '开始时间', dataIndex: "startDate", key: "startDate", customRender: defaultDateCustomRender },
  { title: '结束时间', dataIndex: "signendTime", key: "signendTime", customRender: defaultDateCustomRender },
  { title: '联系人', dataIndex: "contacts", key: "contacts", },
  { title: '联系方式', dataIndex: "phone", key: "phone", },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, formMixin],
  components: {
    UserModal,AddList
  },
  data() {
    return {
      dateFormat,
      columns,
      queryParamFixed: {
        systemType: 'education'
      },
      listUrl: homeEducationInfo.dockingmeetingList,
      listKeyField: "id",
      form: {
        id: null,
      },
      rules: {
        id: [],
        activityId: [],
        name: [dataCheck.required({})],
        phone: [dataCheck.required({}),dataCheck.mobile_phone],
        applyNum: [dataCheck.required({ type: 'number' })]
      }
    }
  },
  computed: {
    submitUrl() {
      return activity.save
    }
  },
  methods: {
    diffTime(endtime) {
      let now = new Date() //当前时间
      //如果传2022-02-22 14:15:00要转化成 2022/02/22 14:15:00
      let end = new Date(endtime.replace(/-/g, "/")) //对比时间
      if (now.getTime() > end.getTime()) {
        //当前时间比指定时间大
        return false
      } else {
        //小于指定时间
        return true
      }
    },
    baoming(record) {
      this.visible = true;
      this.form.name = null
      this.form.phone = null
      this.form.applyNum = null
      this.form.activityId = record.id
    },
    onDetail(record) {
      this.getAction({
        url: homeEducationInfo.dockingmeetingDetail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('detailModal', res);
      })
    },
    handleOk() {
      this.loadData()
    },
    onShowBaoming(record) {
      this.getAction({
        url: activityApi.pageList,
        params: {
          activityId: record.id,
          systemType: 'education'
        }
      }).then(res => {
        console.log('res', res)
        let obj = {
          listData: res.records
        }
        console.log(obj)
        this.onShowModal('listModal', obj)
      })
    }
  }
}
</script>

<style scoped></style>
